import { SeoHead } from "@/components/SeoHead"

export default function ReportNotFound() {
  return (
    <>
      <SeoHead seo={{ title: "Report not found", noIndex: true }} />
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
        <div className="max-w-lg w-full text-center space-y-6">
          <h1 className="font-display text-2xl">Report not found</h1>
          <p className="text-zinc-600">
            This report link is no longer active. If you believe you should
            have access, please reach out to your coach.
          </p>
        </div>
      </div>
    </>
  )
}
